function waitForClevertapToLoad() {
  return new Promise((e) => {
    const t = setInterval(() => {
      window.clevertap && window.clevertap.event && (clearInterval(t), e());
    }, 100);
  });
}
waitForClevertapToLoad();

function getCurrentPincode() {
  try {
    return (
      localStorage.getItem("sddPincode") ||
      localStorage.getItem("cartPincode") ||
      (typeof custZip !== "undefined" && custZip) ||
      ""
    );
  } catch (err) {
    return (typeof custZip !== "undefined" && custZip) || "";
  }
}

let marketingUserId = null,
  marketingUtmSource = null,
  marketingUtmMedium = null,
  marketingUtmCampaign = null;
var checkDataLayer = setInterval(function () {
  void 0 !== window.dataLayer &&
    dataLayer.some((e) => e.marketing) &&
    (clearInterval(checkDataLayer),
    (marketingUserId = dataLayer.find((e) => e.marketing).marketing.user_id),
    (marketingUtmSource = dataLayer.find((e) => e.marketing).marketing
      .utm_source),
    (marketingUtmMedium = dataLayer.find((e) => e.marketing).marketing
      .utm_medium),
    (marketingUtmCampaign = dataLayer.find((e) => e.marketing).marketing
      .utm_campaign));
}, 50);

async function triggerSearchEvent(
  e,
  { searchType: t, lastTypedQuery: a, latency: r, elementId: i },
) {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("Search_Text_Click_w", {
      "Click Type": e,
      SearchType: t,
      "Last Typed Query": a,
      Latency: r,
      "Common Element ID": i,
      Page_Name: pageName,
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

async function fireSearchResultsEvents() {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("PLP_Search_Result_w", {
      "Number of Results": document.title.replace("Search: ", "").split(" ")[0],
      "List of Sku in Page 1":
        document.querySelectorAll("li #hidden_sku").length > 0
          ? Array.from(document.querySelectorAll("li #hidden_sku"))
              .map((e) => e.value)
              .join(",")
          : "",
      "Source Query": getSearchQuery(),
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }),
    clevertap.event.push("Page_Viewed_search_w", {
      "Number of Results": document.title.replace("Search: ", "").split(" ")[0],
      "List of Sku in Page":
        document.querySelectorAll("li #hidden_sku").length > 0
          ? Array.from(document.querySelectorAll("li #hidden_sku"))
              .map((e) => e.value)
              .join(",")
          : "",
      page_index: getPageIndex(),
      "Source Query": getSearchQuery(),
      Page_Name: pageName,
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

function isSearchResultPage() {
  const e = new URL(window.location.href).searchParams;
  return !(!e.has("q") && !e.has("_psq"));
}

function getPageIndex() {
  const e = new URL(window.location.href).searchParams;
  return e.has("page") ? e.get("page") : 1;
}

async function firePLPScrolledEvent(e, t) {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("PLP_browsed_scrolled_w", {
      "page Index": e,
      "list of SKU in Page": JSON.stringify(t),
      "source Query": getSearchQuery(),
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

async function fireSearchIconClickEvent(e) {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("Search_Icon_Click_w", {
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: e,
    }));
}

async function triggerSearchInputEvent(e, t, a, r) {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("Search_Suggestions_Loaded_w", {
      Is_Suggestion_Loaded: e,
      List_of_Suggestions_Query: JSON.stringify(t),
      List_of_Suggestions_Product: JSON.stringify(a),
      Latency_to_First_Suggestion: r,
      Page_Name: pageName,
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

async function fireSearchSelectEvent(e, t, a, r) {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("Search_Suggestions_Click_w", {
      Click_Type: e,
      "Search Thread": t,
      ["Search Query" === e ? "Search Query" : "Search SKU"]:
        "Search Query" === e ? a : r,
      Page_Name: pageName,
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

async function fireSearchCloseClickEvent(e, t, a) {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("Search_Close_w", {
      Close_Type: e,
      "Search Query": t,
      Search_Suggestions_Loaded: a,
      Page_Name: pageName,
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

async function fireAddToCartEvent(e, t, a, r, i) {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("Add_To_Cart_w", {
      get_it_by_text: e,
      sku_id: t,
      Collection_id: a,
      product_title: r,
      price: i,
      dateTimeAttributes: new Date().toISOString(),
      platform_source: marketingUtmSource || "",
      platform_medium: marketingUtmMedium || "",
      platform_campaign: marketingUtmCampaign || "",
      logged_in: custId.length > 0 ? "Yes" : "No",
      Page_Name: pageName,
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

async function fireAddToWishlistEvent(e, t, a, r, i) {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("Add_To_Wishlist_w", {
      platform_source: marketingUtmSource || "",
      platform_medium: marketingUtmMedium || "",
      platform_campaign: marketingUtmCampaign || "",
      locationAttributes: custZip || "",
      product_id: e,
      get_it_by_text: t,
      sku: a,
      product_title: r,
      price: i,
      dateTimeAttributes: new Date().toISOString(),
      logged_in: custId.length > 0 ? "Yes" : "No",
      Page_Name: pageName,
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

async function firePageViewedEvent() {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("Page_Viewed_w", {
      display_title: pageTitle,
      Collection_id: document.getElementById("hidden-collection-id")
        ? document.getElementById("hidden-collection-id").value
        : "",
      link_url: window.location.href,
      link_clicked: window.location.href,
      logged_in: custId.length > 0 ? "Yes" : "No",
      platform_source: marketingUtmSource || "",
      platform_medium: marketingUtmMedium || "",
      platform_campaign: marketingUtmCampaign || "",
      Page_Name: pageName,
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

async function fireCartViewedEvent(e, t, a) {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("View_Cart_w", {
      quantities: JSON.stringify(e),
      prices: JSON.stringify(t),
      items: JSON.stringify(a),
      logged_in: custId.length > 0 ? "Yes" : "No",
      platform_source: marketingUtmSource || "",
      platform_medium: marketingUtmMedium || "",
      platform_campaign: marketingUtmCampaign || "",
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

async function fireCartCreatedEvent(e, t) {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("Cart_Created_w", {
      pageViewed: window.location.href,
      logged_in: custId.length > 0 ? "Yes" : "No",
      item: e,
      price: t,
      platform_source: marketingUtmSource || "",
      platform_medium: marketingUtmMedium || "",
      platform_campaign: marketingUtmCampaign || "",
      Page_Name: pageName,
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

async function fireBuyNowEvent(e, t, a, r, i, n, s) {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("Buy_Now_w", {
      Is_mto: e,
      Metal: t,
      logged_in: custId.length > 0 ? "Yes" : "No",
      sku_id: a,
      name: r,
      price: i,
      originalPrice: n,
      variant_id: s,
      platform_source: marketingUtmSource || "",
      platform_medium: marketingUtmMedium || "",
      platform_campaign: marketingUtmCampaign || "",
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

async function fireSortClickEvent(e) {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("Soting_w", {
      sortName: e,
      Page_Name: pageName,
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

async function fireLogoClickEvent() {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("Logo_Click_w", {
      Page_Name: pageName,
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

async function firePincodeClickEvent() {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("Pincode_Click_w", {
      platform_source: marketingUtmSource || "",
      Page_Name: pageName,
      "session ID": marketingUserId || "",
      "User ID": custId,
      pincode: getCurrentPincode(),
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

async function firePincodeEnterEvent(e) {
  (window.clevertap || (await waitForClevertapToLoad()),
    clevertap.event.push("Pincode_Enter_w", {
      pincode: e,
      platform_source: marketingUtmSource || "",
      Page_Name: pageName,
      "session ID": marketingUserId || "",
      "User ID": custId,
      Is_search_result: isSearchResultPage() ? "Yes" : "No",
    }));
}

function getSearchQuery() {
  const e = new URL(window.location.href),
    t = e.searchParams.get("q") || e.searchParams.get("_psq");
  return t ? decodeURIComponent(t.replace(/\+/g, " ")) : "";
}

document.addEventListener("DOMContentLoaded", () => {
  window.trackIfStays(() => {
    (isSearchResultPage() && setTimeout(() => fireSearchResultsEvents(), 1e3),
      firePageViewedEvent(),
      fireUniversalPageViewedEvent());
  });
  (window.location.pathname.includes("/cart") &&
    fireCartViewedEvent(
      Array.from(document.querySelectorAll(".cart-item")).map((e) => ({
        item: e.querySelector(".cart-item__name")
          ? e.querySelector(".cart-item__name").textContent.trim()
          : "",
        quantity: e.querySelector(".quantity__input")
          ? e.querySelector(".quantity__input").value
          : "",
      })),
      Array.from(document.querySelectorAll(".cart-item")).map((e) => ({
        item: e.querySelector(".cart-item__name")
          ? e.querySelector(".cart-item__name").textContent.trim()
          : "",
        price: e.querySelector(".price")
          ? e.querySelector(".price").textContent.trim()
          : "",
      })),
      Array.from(document.querySelectorAll(".cart-item__name")).map((e) =>
        e.textContent.trim(),
      ),
    ),
    document.querySelector(".product-form__buy") &&
      document
        .querySelector(".product-form__buy")
        .addEventListener("click", () => {
          const e = document.querySelector(".main__title.gold")
            ? "Gold"
            : "Silver";
          fireBuyNowEvent(
            "No",
            e,
            document.querySelector("#product__id").value.trim(),
            "Gold" === e
              ? document.querySelector(".prod_desc_title").textContent.trim()
              : document.querySelector(".main__title").textContent.trim(),
            document
              .querySelector(".price-item--sale")
              .textContent.replace("₹", "")
              .replace(",", "")
              .trim(),
            document
              .querySelector(".price-item--regular")
              .textContent.replace("₹", "")
              .replace(",", "")
              .trim(),
            document.querySelector("#product__varid").value.trim(),
          );
        }),
    document
      .querySelector(".header__heading-link")
      ?.addEventListener("click", () => {
        fireLogoClickEvent();
      }));
});

function getPageType() {
  const path = window.location.pathname;
  if (path === "/") return "home";

  const map = {
    "/cart": "cart",
    "/checkout": "checkout",
    "/address": "address",
  };

  if (map[path]) return map[path];
  if (/\/(products?|pdp)[\/-]/i.test(path)) return "pdp";
  if (/\/(collections?|plp)[\/-]/i.test(path)) return "plp";

  return "other";
}

function getPageNameUniversal() {
  return window.pageName || document.title || getPageType();
}

function getCollectionIdUniversal() {
  return document.getElementById("hidden-collection-id")?.value || null;
}

function getMetalTypeUniversal() {
  const url = window.location.href.toLowerCase();
  if (url.includes("products")) {
    if (
      document.querySelector("#product__sku") &&
      document.querySelector("#product__sku").value
    ) {
      const sku = document.querySelector("#product__sku").value;
      if (sku.includes("GD")) return "Gold";
      if (sku.includes("OM")) return "Demifine";
      return "Silver";
    }
  }
  return "Other";
}

async function fireUniversalPageViewedEvent() {
  await waitForClevertapToLoad();
  const payload = {
    page_type: getPageType(),
    page_name: getPageNameUniversal(),
    metal_type: getMetalTypeUniversal(),
    collection_id: getCollectionIdUniversal(),
    is_search_result: isSearchResultPage(),
    pincode: getCurrentPincode(),
  };
  clevertap.event.push(window.EVENT_NAME.PAGE_VIEWED, payload);
}

function getDestionation(element) {
  return element.href;
}

function inferModuleDetails(clickedElement) {
  let moduleType = "unknown";
  let moduleName = "unknown";
  const section = clickedElement.closest(
    '.shopify-section, section, [id^="shopify-section"]',
  );
  if (section) {
    const sectionIdentifiers = (
      section.className +
      " " +
      section.id
    ).toLowerCase();
    if (
      sectionIdentifiers.includes("banner") ||
      sectionIdentifiers.includes("slideshow") ||
      sectionIdentifiers.includes("hero")
    ) {
      moduleType = "banner";
    } else if (
      sectionIdentifiers.includes("recommendation") ||
      sectionIdentifiers.includes("related")
    ) {
      moduleType = "recommendation";
    } else if (
      sectionIdentifiers.includes("collection-list") ||
      sectionIdentifiers.includes("category-list")
    ) {
      moduleType = "category";
    } else if (
      sectionIdentifiers.includes("featured-collection") ||
      sectionIdentifiers.includes("collection")
    ) {
      moduleType = "collection";
    } else if (sectionIdentifiers.includes("product-grid")) {
      moduleType = "product-grid";
    }
    const heading = section.querySelector(
      "h1, h2, h3, .title, .heading, .banner__heading",
    );
    if (heading && heading.innerText) {
      moduleName = heading.innerText.trim();
    }
  }
  if (moduleName === "unknown" || moduleName === "") {
    if (clickedElement.innerText && clickedElement.innerText.trim() !== "") {
      moduleName = clickedElement.innerText.trim();
    } else if (
      clickedElement.querySelector("img") &&
      clickedElement.querySelector("img").alt
    ) {
      moduleName = clickedElement.querySelector("img").alt;
    } else if (clickedElement.href) {
      let pathPart = clickedElement.href.split("/").pop().split("?")[0];
      moduleName = pathPart.replace(/-/g, " ");
    }
  }
  return { moduleType, moduleName };
}

function fireModuleClickedEvent(element) {
  const inferredData = inferModuleDetails(element);
  const eventData = {
    event_name: window.EVENT_NAME.MODULE_CLICKED,
    page_type: getPageType() || "unknown",
    metal_type: getMetalTypeUniversal() || "unknown",
    module_type: element.dataset.moduleType || inferredData.moduleType,
    module_name: element.dataset.moduleName || inferredData.moduleName,
    destination_type: getDestionation(element) || "unknown",
    page_index: getPageIndex(),
    pincode: getCurrentPincode(),
  };
  if (window.clevertap) {
    clevertap.event.push(window.EVENT_NAME.MODULE_CLICKED, eventData);
  }
}

document.addEventListener("click", function (e) {
  const cta = e.target.closest(
    ".js-module-cta, .full-unstyled-link, .shopify-section a",
  );
  if (!cta) return;
  const isSearchClick = e.target.closest(
    ".predictive-search, .search-modal, #product-grid, .search-results",
  );
  if (!isSearchClick) {
    fireModuleClickedEvent(cta);
  }
});

function getCollectionName() {
  const el = document.querySelector("[data-collection-name]");
  if (el && el.dataset.collectionName) return el.dataset.collectionName;
  const meta = document.querySelector('meta[name="collection"]');
  if (meta && meta.content) return meta.content;
  return document.title
    .replace(/^Search:\s*/i, "")
    .split("|")[0]
    .trim();
}

function getPLPSort() {
  const el = document.querySelector(".js-plp-sort-control");
  if (el) {
    return el.value || el.getAttribute("data-sort") || "";
  }
  return "";
}

function getPLPFilters() {
  const applied = [];
  const params = new URLSearchParams(window.location.search);
  params.forEach((value, key) => {
    if (key.toLowerCase().includes("filter")) {
      let cleanKey = key
        .replace(/Filter-filter\.p\.m\.properties\./i, "")
        .replace(/filter\.v\.price\./i, "Price ")
        .replace(/filter\.v\.option\./i, "")
        .replace(/filter\.p\.vendor/i, "Brand")
        .replace(/filter\.p\.product_type/i, "Category");
      applied.push(`${cleanKey}: ${value}`);
    }
  });
  if (applied.length === 0) {
    document
      .querySelectorAll(".active-facets__button-inner, .js-active-filter")
      .forEach((el) => {
        let text = el.textContent.replace(/✕|X/gi, "").trim();
        if (text) applied.push(text);
      });
  }
  return [...new Set(applied)];
}

function getPLPProductsData() {
  const productCards = document.querySelectorAll("#product-grid .grid__item");
  return Array.from(productCards).map((card) => {
    const skuInput = card.querySelector('input[id="hidden_sku"]');
    const typeInput = card.querySelector('input[id="hidden_type"]');
    const titleInput = card.querySelector('input[id="hidden_title"]');
    const priceInput = card.querySelector('input[id="hidden_price"]');
    return {
      sku: skuInput ? skuInput.value : "",
      category: typeInput ? typeInput.value : "",
      title: titleInput ? titleInput.value : "",
      price: priceInput ? Number(priceInput.value) : 0,
    };
  });
}

function debouncePLPImpression(fn, delay = 300) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(fn, delay);
  };
}

async function fireProductListViewedEvent() {
  if (getPageType() !== "plp" && !isSearchResultPage()) return;
  try {
    await waitForClevertapToLoad();
    const urlParams = new URLSearchParams(window.location.search);
    const isSearch = isSearchResultPage();
    const productData = getPLPProductsData();
    const skus = productData.map((p) => p.sku).filter(Boolean);
    const payload = {
      event_name: "Product List Viewed",
      collection_id: getCollectionIdUniversal() || "na",
      collection_name: getCollectionName() || "General",
      product_count: productData.length,
      page_index: parseInt(getPageIndex(), 10) || 1,
      list_context: isSearch ? "search" : "browse",
      list_name: isSearch
        ? "Search Results"
        : getCollectionName() || "Collection",
      list_type: "algorithmic",
      sort: urlParams.get("sort_by") || "best-selling",
      filters_applied: getPLPFilters(),
      SKUs: skus,
      category: productData.length > 0 ? productData[0].category : "",
      pincode: getCurrentPincode(),
    };
    if (window.clevertap) {
      window.clevertap.event.push(
        window.EVENT_NAME.PRODUCT_LIST_VIEWED,
        payload,
      );
    }
  } catch (err) {
    console.error("PLP Impression error:", err);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (getPageType() === "plp" || isSearchResultPage()) {
    window.trackIfStays(() => {
      setTimeout(() => {
        fireProductListViewedEvent();
      }, 1200);
    });
  }
});

function getProductCardData(card, position) {
  const productId = card.querySelector('input[id="hidden_id"]')?.value || "";
  const variantId =
    card.querySelector('input[id="hidden_variant"]')?.value || "";
  const sku = card.querySelector('input[id="hidden_sku"]')?.value || "";
  const category = card.querySelector('input[id="hidden_type"]')?.value || "";
  const price = card.querySelector('input[id="hidden_price"]')?.value || "";
  const pageType = getPageType();
  const isSale =
    card.querySelector(".price--on-sale") !== null ||
    card.querySelector('.badge:contains("Sale")') !== null;
  const priceDrop = isSale ? "yes" : "no";
  let deliveryPromise = "";
  const sddLineOne = card.querySelector(".sdd-text#line_one");
  const sddLineTwo = card.querySelector(".sdd-text#line_two");
  if (sddLineOne && sddLineOne.innerText.trim() !== "") {
    deliveryPromise = sddLineOne.innerText.trim();
    if (sddLineTwo && sddLineTwo.innerText.trim() !== "") {
      deliveryPromise += " " + sddLineTwo.innerText.trim();
    }
  } else {
    deliveryPromise = "standard";
  }
  return {
    event_name: window.EVENT_NAME.PRODUCT_CARD_CLICKED,
    list_context: "search",
    list_name: "Search Results",
    list_type: "algorithmic",
    position: position,
    product_id: productId,
    variant_id: variantId,
    sku: sku,
    category: category.toLowerCase(),
    Price: price,
    "Price Drop": priceDrop,
    delivery_promise: deliveryPromise,
    "Page Type": pageType,
    pincode: getCurrentPincode(),
  };
}

async function fireProductCardClickedEvent(card, position) {
  try {
    await waitForClevertapToLoad();
    const payload = getProductCardData(card, position + 1);
    if (window.clevertap && window.clevertap.event) {
      window.clevertap.event.push(
        window.EVENT_NAME.PRODUCT_CARD_CLICKED,
        payload,
      );
    }
  } catch (err) {
    console.error("Tracking error:", err);
  }
}

document.addEventListener("click", async function (e) {
  const clickedInteractiveElement = e.target.closest(
    "button, form, manage-wishlist, .quick-add, .heart",
  );
  if (clickedInteractiveElement) return;
  const card = e.target.closest("li.grid__item");
  if (!card) return;
  // Only proceed if this grid__item contains a .card__content child (i.e., is a real product card)
  if (!card.querySelector(".card__content")) return;
  const link = card.querySelector('a[href*="/products/"]');
  if (!link) return;
  const clickedLink = e.target.closest("a");
  const clickedImage = e.target.closest(".card__media");
  if (!clickedLink && !clickedImage) return;
  const cards = Array.from(document.querySelectorAll("li.grid__item")).filter(
    (c) => c.querySelector(".card__content"),
  );
  const position = cards.indexOf(card);
  if (position === -1) return;
  e.preventDefault();
  const trackingPromise = fireProductCardClickedEvent(card, position);
  const fallbackTimeout = new Promise((resolve) => setTimeout(resolve, 300));
  await Promise.race([trackingPromise, fallbackTimeout]);
  window.location.href = link.href;
});

const SEARCH_MIN_LENGTH = 3;

async function fireSearchInitiatedEvent(
  suggestionQueries,
  suggestionProducts,
  latency,
) {
  const searchInput = document.querySelector('input[name="q"]');
  const queryText = searchInput ? searchInput.value.trim() : "";
  if (queryText.length < 3) {
    console.warn(
      `Search Initiated blocked: "${queryText}" is under 3 characters.`,
    );
    return;
  }
  try {
    await waitForClevertapToLoad();
    const type = typeof getPageType === "function" ? getPageType() : "other";
    let mappedSource = "other";
    if (type === "home") mappedSource = "home page";
    else if (type === "plp") mappedSource = "PLP";
    else if (type === "pdp") mappedSource = "PDP";
    const payload = {
      query: queryText,
      search_type: "suggestion",
      trigger: "suggestion_loaded",
      source: mappedSource,
      pincode: getCurrentPincode(),
    };
    if (window.clevertap && window.clevertap.event) {
      window.clevertap.event.push(window.EVENT_NAME.SEARCH_INITIATED, payload);
    }
  } catch (err) {
    console.error("Search Initiated tracking error:", err);
  }
}

document.addEventListener("click", function (e) {
  const suggestionItem = e.target.closest(
    ".predictive-search__item, .search-suggestion",
  );
  if (suggestionItem) {
    const query = suggestionItem.innerText.trim();
    fireSearchInitiatedEvent({
      query: query,
      search_type: "suggestion",
      trigger: "suggestion",
    });
    return;
  }
  const trendingItem = e.target.closest(".trending-search-item, .trending-tag");
  if (trendingItem) {
    const query = trendingItem.innerText.trim();
    fireSearchInitiatedEvent({
      query: query,
      search_type: "suggestion",
      trigger: "trending",
    });
    return;
  }
  const recentItem = e.target.closest(".recent-search-item, .last-searched");
  if (recentItem) {
    const query = recentItem.innerText.trim();
    fireSearchInitiatedEvent({
      query: query,
      search_type: "suggestion",
      trigger: "last searched",
    });
    return;
  }
  const voiceIcon = e.target.closest(".voice-search-btn");
  if (voiceIcon) {
    fireSearchInitiatedEvent({
      query: "",
      search_type: "voice",
      trigger: "voice_click",
    });
  }
});

async function fireSearchResultsViewedEvent({
  query,
  result_count,
  page_index,
  sort,
  filters_applied,
  SKUs,
}) {
  try {
    await waitForClevertapToLoad();
    const payload = {
      query: query || "",
      result_count: typeof result_count === "number" ? result_count : 0,
      page_index: typeof page_index === "number" ? page_index : 1,
      sort: sort || "relevance",
      filters_applied: Array.isArray(filters_applied) ? filters_applied : [],
      SKUs: Array.isArray(SKUs) ? SKUs : [],
      pincode: getCurrentPincode(),
    };
    if (window.clevertap) {
      window.clevertap.event.push(
        window.EVENT_NAME.SEARCH_RESULTS_VIEWED,
        payload,
      );
    }
  } catch (err) {
    console.error("Search Results Viewed tracking error:", err);
  }
}

async function fireSearchResultClickedEvent({
  query,
  result_position,
  product_id,
  variant_id,
  sku,
  category,
  price,
  metal_type,
  is_mto,
}) {
  try {
    await waitForClevertapToLoad();

    const payload = {
      query: query || "",
      result_position:
        typeof result_position === "number" ? result_position : 1,
      product_id: product_id || "",
      variant_id: variant_id || "",
      sku: sku || "",
      Category: category || "",
      price: price ? Number(price) : 0,
      metal_type: metal_type || "Unknown",
      is_mto: typeof is_mto === "boolean" ? is_mto : false,
      pincode: getCurrentPincode(),
    };
    if (window.clevertap && window.clevertap.event) {
      window.clevertap.event.push(
        window.EVENT_NAME.SEARCH_RESULT_CLICKED,
        payload,
      );
    }
  } catch (err) {
    console.error("Search Result Click tracking error:", err);
  }
}

document.addEventListener("click", async function (e) {
  const recLink = e.target.closest(
    ".predictive-search__item, .predictive-search__list-item a",
  );
  if (!recLink) return;
  const isProduct = !!recLink.closest(
    "#predictive-search-results-products-list",
  );
  const isQuery = !!recLink.closest("#predictive-search-results-queries-list");
  const isSearchFor = !!recLink.closest(
    ".predictive-search__search-for-button",
  );
  let clickSource = "predictive_search_general";
  if (isProduct) clickSource = "predictive_suggestion_product";
  else if (isQuery) clickSource = "predictive_suggestion_query";
  else if (isSearchFor) clickSource = "predictive_search_for_term";
  const title =
    recLink.querySelector(".predictive-search__item-heading")?.innerText ||
    recLink.innerText ||
    "";
  const sku = recLink.dataset.sku || recLink.getAttribute("data-sku") || "";
  const priceText =
    recLink.querySelector(".price-item--sale")?.innerText || "0";
  const price = parseFloat(priceText.replace(/[^0-9.]/g, "")) || 0;
  const parentList = recLink.closest("ul");
  let result_position = 1;
  if (parentList) {
    const allLinksInList = Array.from(parentList.querySelectorAll("a, button"));
    result_position = allLinksInList.indexOf(recLink) + 1;
  }
  const allSkuElements = document.querySelectorAll(
    ".predictive-search [data-sku]",
  );
  const visibleSKUs = Array.from(allSkuElements)
    .map((el) => el.getAttribute("data-sku"))
    .filter(Boolean);
  try {
    await fireSearchResultClickedEvent({
      source: clickSource,
      result_position: result_position,
      product_id: "",
      variant_id: "",
      sku: sku,
      category: isProduct ? "Product" : "Suggestion",
      price: price,
      metal_type: title.toLowerCase().includes("gold")
        ? "gold"
        : title.toLowerCase().includes("silver")
          ? "silver"
          : "Other",
      is_mto: !!recLink.querySelector(".mto-btns, .mto-customise"),
    });
    await new Promise((resolve) => setTimeout(resolve, 200));
    await fireSearchResultsViewedEvent({
      source: clickSource,
      result_count: visibleSKUs.length,
      page_index: 1,
      sort: "relevance",
      filters_applied: [],
      SKUs: visibleSKUs,
    });
  } catch (err) {
    console.error("New tracking functions failed:", err);
  }
});

async function fireUniversalAddToCartEvent({
  product_id,
  variant_id,
  sku,
  price,
  quantity,
  metal_type,
  is_mto,
  source,
}) {
  await waitForClevertapToLoad();
  const payload = {
    event_name: window.EVENT_NAME.ADD_TO_CART,
    product_id: product_id || "",
    variant_id: variant_id || "",
    sku: sku || "",
    price: price !== undefined && price !== null ? Number(price) : "",
    quantity:
      quantity !== undefined && quantity !== null ? Number(quantity) : 1,
    metal_type: metal_type || "",
    is_mto: typeof is_mto === "boolean" ? is_mto : false,
    source: source || getPageType() || "other",
    pincode: getCurrentPincode(),
  };
  if (window.clevertap) {
    clevertap.event.push(window.EVENT_NAME.ADD_TO_CART, payload);
  }
}

document.addEventListener("click", function (e) {
  const btn = e.target.closest('.quick-add__submit, button[name="add"]');
  if (!btn) return;
  if (btn.hasAttribute("disabled") || btn.classList.contains("disabled"))
    return;
  const form = btn.closest('form[action="/cart/add"]');
  const card = btn.closest(".grid__item, .card-wrapper") || document;
  const product_id =
    form?.querySelector('input[name="product-id"]')?.value || "";
  const variant_id = form?.querySelector('input[name="id"]')?.value || "";
  let title = card.querySelector('input[id="hidden_title"]')?.value;
  if (!title) {
    const titleEl = card.querySelector(".card__heading a");
    title = titleEl ? titleEl.innerText.trim() : btn.dataset.handle || "";
  }
  const sku =
    btn.closest(".grid__item").querySelector('input[id="hidden_sku"]')?.value ||
    "";
  let price = card.querySelector('input[id="hidden_price"]')?.value;
  if (!price) {
    const priceEl = card.querySelector(
      ".price-item--sale, .price-item--regular",
    );
    price = priceEl ? priceEl.innerText.replace(/[^0-9.]/g, "") : "";
  }
  const is_mto =
    card.querySelector(".mto-btns, .mto-customise, .header_mto_bold") !== null;
  let metal_type = "";
  const lowerTitle = title.toLowerCase();
  if (lowerTitle.includes("gold")) metal_type = "gold";
  else if (lowerTitle.includes("silver")) metal_type = "silver";
  else
    metal_type =
      typeof getMetalTypeUniversal === "function"
        ? getMetalTypeUniversal()
        : "Other";
  const qtyInput = form?.querySelector('input[name="quantity"]');
  const quantity = qtyInput ? Number(qtyInput.value) : 1;
  fireUniversalAddToCartEvent({
    product_id,
    variant_id,
    sku,
    price,
    quantity,
    metal_type,
    is_mto,
    source: typeof getPageType === "function" ? getPageType() : "other",
  });
});

async function fireUniversalAddToWishlistEvent({
  product_id,
  variant_id,
  sku,
  price,
  quantity,
  metal_type,
  is_mto,
  category,
  source,
}) {
  try {
    await waitForClevertapToLoad();
    const payload = {
      product_id: product_id || "",
      variant_id: variant_id || "",
      sku: sku || "",
      price: price ? Number(price) : 0,
      quantity: quantity ? Number(quantity) : 1,
      metal_type: metal_type || "Unknown",
      is_mto: typeof is_mto === "boolean" ? is_mto : false,
      Category: category || "",
      source: source || "other",
      pincode: getCurrentPincode(),
    };
    if (window.clevertap) {
      clevertap.event.push(window.EVENT_NAME.ADD_TO_WISHLIST, payload);
    }
  } catch (err) {
    console.error("Wishlist tracking error:", err);
  }
}

document.addEventListener("click", function (e) {
  const btn = e.target.closest(".heart") || e.target.closest(".product-heart");
  if (!btn) return;
  const card = btn.closest(".grid__item, .card-wrapper") || document;
  const product_id =
    btn.dataset.productid ||
    card.querySelector('input[id="hidden_id"]')?.value ||
    "";
  const variant_id =
    btn.dataset.variantid ||
    card.querySelector('input[id="hidden_variant"]')?.value ||
    "";
  const sku =
    btn.dataset.sku ||
    card.querySelector('input[id="hidden_sku"]')?.value ||
    "";
  const price =
    btn.dataset.price ||
    card.querySelector('input[id="hidden_price"]')?.value ||
    "";
  const title =
    btn.dataset.title ||
    card.querySelector('input[id="hidden_title"]')?.value ||
    "";
  const categoryRaw =
    card.querySelector('input[id="hidden_type"]')?.value || "";
  const category = categoryRaw.toLowerCase();
  const is_mto =
    card.querySelector(".mto-btns, .mto-customise, .header_mto_bold") !== null;
  let metal_type = "";
  if (sku.includes("GD")) metal_type = "gold";
  else if (sku.includes("OM")) metal_type = "demifine";
  else metal_type = "silver";
  const quantity = 1;
  fireUniversalAddToWishlistEvent({
    product_id,
    variant_id,
    sku,
    price,
    quantity,
    metal_type,
    is_mto,
    category,
    source: getPageType(),
  });
});

async function fireUniversalBuyNowEvent({
  product_id,
  variant_id,
  sku,
  price,
  quantity,
  metal_type,
  is_mto,
  Category,
}) {
  try {
    await waitForClevertapToLoad();
    const payload = {
      product_id: product_id || "",
      variant_id: variant_id || "",
      sku: sku || "",
      price: price ? Number(price) : 0,
      quantity: quantity ? Number(quantity) : 1,
      metal_type: metal_type || "Unknown",
      is_mto: typeof is_mto === "boolean" ? is_mto : false,
      Category: Category || "",
      pincode: getCurrentPincode(),
    };
    if (window.clevertap && window.clevertap.event) {
      window.clevertap.event.push(window.EVENT_NAME.PRODUCT_ADDED, payload);
    }
  } catch (err) {
    console.error("Buy Now tracking error:", err);
  }
}

document
  .querySelector(".product-form__buy")
  ?.addEventListener("click", function () {
    fireUniversalBuyNowEvent({
      event_name: window.EVENT_NAME.PRODUCT_ADDED,
      product_id: document.querySelector("#product__id")?.value || "",
      variant_id: document.querySelector("#product__varid")?.value || "",
      sku: document.querySelector("#product__sku")?.value || "",
      price:
        document
          .querySelector(".price-item--sale")
          ?.textContent.replace("₹", "")
          .replace(",", "")
          .trim() || "",
      metal_type: document.querySelector("#product__sku")?.value.includes("GD")
        ? "gold"
        : document.querySelector("#product__sku")?.value.includes("OM")
          ? "demifine"
          : "silver",
      is_mto: document.querySelector(".mto-border") !== null,
      Category: document.querySelector("#product__type")?.value || "",
    });
  });

document.querySelectorAll(".mto-buy-now").forEach((btn) => {
  btn.addEventListener("click", function () {
    let curProdId = btn.id.replace("mto-buy-now-", "");
    let main_card = document
      .querySelector("#hidden_id[value='" + curProdId + "']")
      .closest(".grid__item");
    fireUniversalBuyNowEvent({
      event_name: window.EVENT_NAME.PRODUCT_ADDED,
      product_id: main_card.querySelector("#hidden_id")?.value || "",
      variant_id: main_card.querySelector("#hidden_variant")?.value || "",
      sku: main_card.querySelector("#hidden_sku")?.value || "",
      price: main_card.querySelector("#hidden_price"),
      metal_type: "gold",
      is_mto: true,
      Category: main_card.querySelector("#hidden_type")?.value || "",
    });
  });
});

async function fireProductPageViewedEvent({
  source,
  product_id,
  variant_id,
  sku,
  price,
  category,
  metal_type,
  is_mto,
  delivery_promise,
  price_drop,
} = {}) {
  try {
    await waitForClevertapToLoad();
    let sourceVal = source;
    if (!sourceVal) {
      let refer = document.referrer || "";
      if (/\/(collections|plp)/i.test(refer)) sourceVal = "plp";
      else if (/[\?&]q=/.test(refer)) sourceVal = "search";
      else if (/\/home|^https?:\/\/[^/]+\/?$/.test(refer))
        sourceVal = "homepage";
      else sourceVal = "other";
    }
    const form = document.querySelector('form[action="/cart/add"]');
    const analytics = window.ShopifyAnalytics?.meta?.product || {};
    const final_product_id =
      product_id ||
      document.querySelector('input[id="hidden_id"]')?.value ||
      form?.querySelector('input[name="product-id"]')?.value ||
      analytics.id?.toString() ||
      "";
    const final_variant_id =
      variant_id ||
      document.querySelector('input[id="hidden_variant"]')?.value ||
      form?.querySelector('input[name="id"]')?.value ||
      window.ShopifyAnalytics?.meta?.selectedVariantId?.toString() ||
      "";
    const final_sku =
      sku ||
      document.querySelector('input[id="hidden_sku"]')?.value ||
      document.querySelector(".product__sku, .sku")?.textContent?.trim() ||
      analytics.variants?.[0]?.sku ||
      "";
    const final_category =
      category ||
      document.querySelector('input[id="hidden_type"]')?.value ||
      analytics.type ||
      "";
    let priceStr =
      price !== undefined
        ? price
        : document.querySelector('input[id="hidden_price"]')?.value ||
          document.querySelector(".price-item--sale, .price-item--regular")
            ?.textContent ||
          "";
    const final_price =
      Number(priceStr.toString().replace(/[^0-9.]/g, "")) || 0;
    const isSale =
      document.querySelector(".price--on-sale") !== null ||
      Array.from(document.querySelectorAll(".badge")).some((el) =>
        el.textContent.trim().includes("Sale"),
      );
    const final_price_drop =
      price_drop !== undefined ? price_drop : isSale ? "yes" : "no";
    const title =
      document.querySelector("h1")?.textContent || document.title || "";
    let final_metal_type = metal_type;
    if (!final_metal_type) {
      const lowerTitle = title.toLowerCase();
      if (lowerTitle.includes("rose gold")) final_metal_type = "rose gold";
      else if (lowerTitle.includes("gold")) final_metal_type = "gold";
      else if (lowerTitle.includes("silver")) final_metal_type = "silver";
      else final_metal_type = "Other";
    }
    let final_is_mto = is_mto;
    if (typeof final_is_mto !== "boolean") {
      final_is_mto = document.querySelector(".mto_border") !== null;
    }
    let final_delivery_promise = delivery_promise || "";
    if (!final_delivery_promise) {
      const sddLineOne = document.querySelector(".sdd-text#line_one");
      const sddLineTwo = document.querySelector(".sdd-text#line_two");
      if (sddLineOne && sddLineOne.innerText.trim() !== "") {
        final_delivery_promise = sddLineOne.innerText.trim();
        if (sddLineTwo && sddLineTwo.innerText.trim() !== "") {
          final_delivery_promise += " " + sddLineTwo.innerText.trim();
        }
      } else {
        final_delivery_promise = "standard";
      }
    }
    const payload = {
      source: sourceVal,
      product_id: final_product_id,
      variant_id: final_variant_id,
      sku: final_sku,
      price: final_price,
      category: final_category.toLowerCase(),
      metal_type: final_metal_type,
      is_mto: final_is_mto,
      delivery_promise: final_delivery_promise,
      "Price Drop": final_price_drop,
      pincode: getCurrentPincode(),
    };
    if (window.clevertap) {
      clevertap.event.push(window.EVENT_NAME.PRODUCT_PAGE_VIEWED, payload);
    }
  } catch (err) {
    console.error("Product Viewed tracking error:", err);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  window.trackIfStays(() => {
    const isFunctionReady = typeof getPageType === "function";
    if (isFunctionReady && getPageType() === "pdp") {
      fireProductPageViewedEvent();
    } else {
      const shopifyPageType = window.ShopifyAnalytics?.meta?.page?.pageType;
      if (shopifyPageType === "product") {
        fireProductPageViewedEvent();
      }
    }
  });
});

async function fireProductImageSwipedEvent({
  product_id,
  image_index,
  source,
}) {
  try {
    await waitForClevertapToLoad();
    let src = source;
    if (!src) {
      const t = typeof getPageType === "function" ? getPageType() : "";
      if (t === "plp") src = "PLP";
      else if (t === "pdp") src = "PDP";
      else src = t || "unknown";
    }
    const payload = {
      product_id: product_id || "",
      image_index: typeof image_index === "number" ? image_index : 1,
      source: src,
      pincode: getCurrentPincode(),
    };
    if (window.clevertap && window.clevertap.event) {
      clevertap.event.push(window.EVENT_NAME.IMAGE_SWIPED, payload);
    }
  } catch (err) {
    console.error("Image swipe tracking error:", err);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    const arrowBtn = e.target.closest(".slider-button");
    if (arrowBtn) {
      extractAndFireImageEvent(arrowBtn);
    }
    const dotBtn = e.target.closest(".slider-counter__link--dots");
    if (dotBtn) {
      extractAndFireImageEvent(dotBtn);
    }
  });
  const sliders = document.querySelectorAll("slider-component .slider");
  sliders.forEach((slider) => {
    let scrollTimeout;
    slider.addEventListener("scroll", function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        extractAndFireImageEvent(slider);
      }, 150);
    });
  });
});

function extractAndFireImageEvent(element) {
  const sliderComponent = element.closest("slider-component");
  if (!sliderComponent) return;
  const sliderId = sliderComponent.getAttribute("id") || "";
  const product_id = sliderId.replace("GalleryViewer-", "");
  const ulList = sliderComponent.querySelector("ul.slider");
  const slides = sliderComponent.querySelectorAll("li.slider__slide");
  let currentIndex = 1;
  if (ulList && slides.length > 0) {
    const scrollLeft = ulList.scrollLeft;
    const slideWidth = slides[0].clientWidth;
    currentIndex = Math.round(scrollLeft / slideWidth) + 1;
  }
  fireProductImageSwipedEvent({
    product_id: product_id,
    image_index: currentIndex,
  });
}

window.hasFiredDeliveryView = false;

async function fireDeliveryOptionViewedEvent({
  delivery_type,
  estimated_days,
}) {
  if (window.hasFiredDeliveryView) return;
  await waitForClevertapToLoad();
  const payload = {
    delivery_type: delivery_type || "standard",
    estimated_days: estimated_days || "",
    pincode: getCurrentPincode(),
  };
  if (window.clevertap) {
    clevertap.event.push("GI-Delivery Option Viewed", payload);
    window.hasFiredDeliveryView = true;
  }
}

function calculateDaysFromText(dateText) {
  if (!dateText) return "";
  return dateText.trim();
}

const observerOptions = {
  root: null,
  threshold: 0.5,
};

const deliveryObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting && !window.hasFiredDeliveryView) {
      const responseEl = document.querySelector("#response1");
      if (responseEl && responseEl.offsetParent !== null) {
        const timeText = responseEl.querySelector("strong")?.innerText || "";
        const isFree = responseEl.innerText.toLowerCase().includes("free");
        fireDeliveryOptionViewedEvent({
          delivery_type: isFree ? "standard_free" : "standard",
          estimated_days: calculateDaysFromText(timeText),
        });
      }
    }
  });
}, observerOptions);

document.addEventListener("DOMContentLoaded", () => {
  window.trackIfStays(() => {
    const deliveryComponent = document.querySelector("delivery-time");
    if (deliveryComponent) {
      deliveryObserver.observe(deliveryComponent);
    }
  });
});

async function fireCartViewedEventnew({ cart_value, item_count }) {
  try {
    await waitForClevertapToLoad();
    const payload = {
      cart_value: cart_value !== undefined ? Number(cart_value) : 0,
      item_count: item_count !== undefined ? Number(item_count) : 0,
      pincode: getCurrentPincode(),
    };
    if (window.clevertap && window.clevertap.event) {
      window.clevertap.event.push(window.EVENT_NAME.CART_VIEWED, payload);
    }
  } catch (err) {
    console.error("Cart Viewed tracking error:", err);
  }
}

async function fireCartUpdatedEvent({
  action,
  product_id,
  cart_value,
  coupon_name,
  coupon_value,
}) {
  try {
    await waitForClevertapToLoad();
    const payload = {
      action: action || "",
      product_id: product_id || "",
      cart_value:
        cart_value !== undefined && cart_value !== null
          ? Number(cart_value)
          : 0,
      coupon_name: coupon_name || "",
      coupon_value:
        coupon_value !== undefined && coupon_value !== null
          ? String(coupon_value)
          : "",
      pincode: getCurrentPincode(),
    };
    if (window.clevertap && window.clevertap.event) {
      window.clevertap.event.push(window.EVENT_NAME.CART_UPDATED, payload);
    }
  } catch (err) {
    console.error("Cart Updated tracking error:", err);
  }
}

async function fetchShopifyCart() {
  try {
    const response = await fetch(window.Shopify.routes.root + "cart.js");
    const cart = await response.json();
    return cart;
  } catch (error) {
    console.error("Error fetching cart data", error);
    return null;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname.includes("/cart")) {
    fetchShopifyCart().then((cart) => {
      if (cart) {
        fireCartViewedEventnew({
          cart_value: cart.total_price / 100,
          item_count: cart.item_count,
        });
      }
    });
  }
  document.addEventListener("click", function (e) {
    const qtyBtn = e.target.closest(
      '.quantity__button, [name="plus"], [name="minus"]',
    );
    const removeBtn = e.target.closest(
      'cart-remove-button, .cart__remove, [href*="/cart/change?line="]',
    );
    if (qtyBtn || removeBtn) {
      let actionType = "quantity_change";
      if (
        removeBtn ||
        (qtyBtn && qtyBtn.name === "minus" && isLastItem(qtyBtn))
      ) {
        actionType = "remove";
      }
      const cartItem = e.target.closest(".cart-item, .drawer__cart-item");
      const product_id = cartItem
        ? cartItem.dataset.productId || cartItem.getAttribute("id")
        : "";
      setTimeout(() => {
        fetchShopifyCart().then((cart) => {
          if (cart) {
            fireCartUpdatedEvent({
              action: actionType,
              product_id: product_id,
              cart_value: cart.total_price / 100,
            });
          }
        });
      }, 700);
    }
  });
});

function isLastItem(btn) {
  const input = btn.parentElement.querySelector("input.quantity__input");
  return input && Number(input.value) <= 1;
}

async function fireCheckoutStartedEvent({ cart_value, item_count }) {
  try {
    await waitForClevertapToLoad();
    const payload = {
      cart_value: typeof cart_value === "number" ? cart_value : 0,
      item_count: typeof item_count === "number" ? item_count : 0,
      pincode: getCurrentPincode(),
    };
    if (window.clevertap && window.clevertap.event) {
      window.clevertap.event.push(window.EVENT_NAME.CHECKOUT_STARTED, payload);
    }
  } catch (err) {
    console.error("Checkout tracking error:", err);
  }
}

document.addEventListener("click", function (e) {
  const checkoutBtn = e.target.closest(
    '#checkout, button[name="checkout"], .cart__checkout-button',
  );
  if (!checkoutBtn) return;
  (async () => {
    try {
      let cart_value = 0;
      let item_count = 0;
      const totalEl = document.querySelector(
        ".totals__subtotal-value, .cart__subtotal, #cart-total",
      );
      if (totalEl) {
        cart_value =
          parseFloat(totalEl.textContent.replace(/[^0-9.]/g, "")) || 0;
      }
      item_count = document.querySelectorAll(
        ".cart-item, .drawer__cart-item",
      ).length;
      if (cart_value === 0) {
        const response = await fetch("/cart.js");
        const cart = await response.json();
        cart_value = cart.total_price / 100;
        item_count = cart.item_count;
      }
      fireCheckoutStartedEvent({ cart_value, item_count });
    } catch (err) {
      console.error("Background checkout tracking failed", err);
    }
  })();
});

async function fireAddressPageViewedEvent(has_saved_address = true) {
  await waitForClevertapToLoad();
  const payload = {
    event_name: "Address Viewed",
    has_saved_address: !!has_saved_address,
    pincode: getCurrentPincode(),
  };
  if (window.clevertap) {
    clevertap.event.push(window.EVENT_NAME.ADDRESS_PAGE_VIEWED, payload);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const isAddressPath = window.location.pathname.includes("/account/addresses");
  if (
    isAddressPath ||
    (typeof getPageType === "function" && getPageType() === "address")
  ) {
    if (
      window.GIVA_TRACKING &&
      !window.GIVA_TRACKING.hasFired("address_page_view")
    ) {
      fireAddressPageViewedEvent(true);
    } else if (!window.GIVA_TRACKING) {
      fireAddressPageViewedEvent(true);
    }
  }
});

async function fireAddressUpdatedEvent({ pincode, city }) {
  await waitForClevertapToLoad();
  const payload = {
    event_name: window.EVENT_NAME.ADDRESS_UPDATED,
    pincode: pincode || getCurrentPincode(),
    city: city || "",
  };
  if (window.clevertap) {
    clevertap.event.push(window.EVENT_NAME.ADDRESS_UPDATED, payload);
  }
}

document.addEventListener("submit", async function (e) {
  const form = e.target;
  const isAddressForm =
    form.action?.includes("/account/addresses") ||
    form.querySelector('input[name="form_type"][value="customer_address"]');
  if (!isAddressForm) return;
  e.preventDefault();
  const zipInput = form.querySelector('input[name="address[zip]"]');
  const cityInput = form.querySelector('input[name="address[city]"]');
  const pincode = zipInput ? zipInput.value.trim() : "";
  const city = cityInput ? cityInput.value.trim() : "";
  if (pincode || city) {
    const trackingPromise = fireAddressUpdatedEvent({ pincode, city });
    const fallbackTimeout = new Promise((resolve) => setTimeout(resolve, 300));
    await Promise.race([trackingPromise, fallbackTimeout]);
  }
  HTMLFormElement.prototype.submit.call(form);
});

async function firePaymentPageViewedEvent(cart_value) {
  try {
    await waitForClevertapToLoad();
    const payload = {
      cart_value: typeof cart_value === "number" ? cart_value : 0,
      pincode: getCurrentPincode(),
    };
    if (window.clevertap && window.clevertap.event) {
      window.clevertap.event.push(
        window.EVENT_NAME.PAYMENT_PAGE_VIEWED,
        payload,
      );
    }
  } catch (err) {
    console.error("Payment Page Viewed tracking error:", err);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const isCheckoutPage =
    window.location.pathname.includes("/checkouts/") ||
    window.location.pathname.includes("/orders/") ||
    (typeof getPageType === "function" && getPageType() === "checkout");
  if (isCheckoutPage) {
    let cart_value = 0;
    if (window.Shopify && window.Shopify.checkout) {
      cart_value = Number(window.Shopify.checkout.total_price);
    } else if (typeof window.cartTotalValue !== "undefined") {
      cart_value = Number(window.cartTotalValue) || 0;
    } else {
      const totalEl = document.querySelector(
        ".payment-due__price, .os-price, [data-checkout-payment-due-target]",
      );
      if (totalEl) {
        let cleanText = totalEl.textContent.replace(/[^0-9.]/g, "");
        cart_value = parseFloat(cleanText) || 0;
      }
    }
    firePaymentPageViewedEvent(cart_value);
  }
});

async function firePaymentMethodSelectedEvent({ payment_method }) {
  await waitForClevertapToLoad();
  const payload = {
    event_name: "Payment Method Selected",
    payment_method: (payment_method || "").toLowerCase(),
    pincode: getCurrentPincode(),
  };
  if (window.clevertap) {
    clevertap.event.push("Payment Method Selected", payload);
  }
}

document.addEventListener("click", function (e) {
  const methodEl = e.target.closest(
    ".js-payment-method, [data-payment-method]",
  );
  if (!methodEl) return;
  let payment_method =
    methodEl.dataset && methodEl.dataset.paymentMethod
      ? methodEl.dataset.paymentMethod
      : (
          methodEl.getAttribute("data-payment-method") ||
          methodEl.textContent ||
          ""
        )
          .trim()
          .toLowerCase();
  if (/^(upi|card|netbanking|wallet)$/.test(payment_method)) {
    firePaymentMethodSelectedEvent({ payment_method });
  }
});

async function firePayNowClickedEvent({ payment_method, final_amount }) {
  await waitForClevertapToLoad();
  const payload = {
    event_name: "Pay Now Clicked",
    payment_method: payment_method || "",
    final_amount:
      final_amount !== undefined && final_amount !== null
        ? Number(final_amount)
        : "",
    pincode: getCurrentPincode(),
  };
  if (window.clevertap) {
    clevertap.event.push("Pay Now Clicked", payload);
  }
}

async function fireOrderCompletedEvent({
  order_id,
  order_value,
  currency,
  payment_method,
  item_count,
  coupon_name,
  coupon_value,
  product_ids,
  skus,
  prices,
}) {
  await waitForClevertapToLoad();
  const payload = {
    event_name: "Order Completed",
    order_id: order_id || "",
    order_value:
      order_value !== undefined && order_value !== null
        ? Number(order_value)
        : 0,
    currency: currency || "INR",
    payment_method: payment_method || "",
    item_count: typeof item_count === "number" ? item_count : 0,
    "coupon name": coupon_name || "",
    "coupon value":
      coupon_value !== undefined && coupon_value !== null
        ? String(coupon_value)
        : "",
    product_ids: Array.isArray(product_ids) ? product_ids : [],
    skus: Array.isArray(skus) ? skus : [],
    prices: Array.isArray(prices) ? prices.map((v) => Number(v)) : [],
    pincode: getCurrentPincode(),
  };
  if (window.clevertap) {
    clevertap.event.push("Order Completed", payload);
  }
}
